<script setup>
import { storeToRefs } from 'pinia'
import { useSideBarStore } from '~/stores/sideBar'

// Sidebar store
const sideBarStore = useSideBarStore()
const { sideBarContent, sideBarOverlayContent, sideBarSubNavContent } = storeToRefs(sideBarStore)

// Fetch route
const route = useRoute()
</script>

<template>
    <!-- sidebar content -->
    <SideBarContent
        :sidebar-content-config="{
            content: sideBarContent,
            callbackFn: async () => {
                await navigateWithSidebarQuery({ route })
            }
        }"
    />
    <!-- sidebar content overlay-->
    <SideBarContent
        :sidebar-content-config="{
            content: sideBarOverlayContent,
            callbackFn: async () => {
                await navigateWithSidebarQuery({ route })
            }
        }"
    />

    <!-- sidebar  subnav content-->
    <SideBarContent
        :sidebar-content-config="{
            content: sideBarSubNavContent,
            callbackFn: async () => {
                await navigateWithSidebarQuery({
                    query: {
                        profile: null
                    },
                    route
                })
            },
            isSubNav: true
        }"
    />
</template>
